export default {
  guests_pay: 'Os clientes pagam {{amount}} no checkout (última taxa de câmbio).',
  missing_rate: 'Ainda não há taxa de câmbio para {{currency}}, por isso os clientes pagam {{amount}} sem conversão.',
};
